import { useEffect, useState } from 'react';
import { API_GRAPHQL } from '../../constants';
//import { authFetch } from '../../helpers/apiActions/authFetch';

export function useRetrieveKjedeVerksteder() {
    const url = `${API_GRAPHQL}`;
    const [verksteder, setVerksteder] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

   

    useEffect(() => {
        async function getVerkstederInfo(url) {
            try {
                setIsLoading(true);
                setIsError(false);

                const userInfo = JSON.parse(localStorage.getItem('user'));

                const adminMail = userInfo?.user.email.toLowerCase();
                let kundeIDToUse = 1; // Default kundeID

                if (adminMail?.endsWith('@intakt.no')) {
                    kundeIDToUse = 2; // Bruk kundeID for intakt.no
                } else if (adminMail?.endsWith('@tesla.no')) {
                    kundeIDToUse = 3; // Bruk kundeID for tesla.no
                }
                else if (adminMail?.endsWith('@volvo.no')) {
                    kundeIDToUse = 4; // Bruk kundeID for tesla.no
                }

                const response = await fetch(url, {
                   method: 'POST',
                   headers: {'Content-Type' : 'application/json'},
                   body: JSON.stringify({
                    query: `{
                        kjede(id:${kundeIDToUse}){
                            data{
                                id
                                attributes{
                                    name
                                    users(pagination: {limit:100}){
                                        data{
                                            id
                                            attributes{
                                                username
                                                address{
                                                    country
                                                    region
                                                }
                                                image{
                                                    data{
                                                        attributes{
                                                            url
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }`
                   }) 
                });
                const json = await response.json();

                // console.log(json);
                
                setVerksteder(json.data.kjede.data.attributes.users.data);
            } catch(error){
                console.log(error);
                setIsError(true);
            } finally{
                setIsLoading(false);
            }
        }
        getVerkstederInfo(url);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);
    return { verksteder, isLoading, isError};
}

export default useRetrieveKjedeVerksteder;






 // useEffect(() => {
    //     async function getVerkstederInfo(url) {
    //         try {
    //             setIsLoading(true);
    //             setIsError(false);

    //             const response = await authFetch(url);
    //             const userData = await response.json();

    //             console.log(userData);
    //             setVerksteder(userData);
    //         } catch(error) {
    //             console.log(error);
    //             setIsError(true);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     }

    //     getVerkstederInfo(url);
    // }, [url]);